module.exports = __webpack_public_path__ + "img/6.a9e1519a.png";